import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, testId }) => (
  <div className="mb-10 sm:mb-14">
    <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-kit">
      {eyebrow}
    </p>
    <h2
      data-testid={testId}
      className="mt-3 font-display text-4xl font-bold uppercase tracking-tight text-white sm:text-5xl"
    >
      {title}
    </h2>
  </div>
);
